const checkIfArray = (array: unknown[]) => (Array.isArray(array) ? array : []);

export default checkIfArray;
